import { BaseIcon } from '../BaseIcon';
import type { BaseIconProps } from '../BaseIcon';

type RefreshIconProps = Omit<BaseIconProps, 'children'>;

export const RefreshIcon = ({ strokeWidth, hasLegacyStrokeStyles, ...props }: RefreshIconProps) => (
  <BaseIcon
    hasLegacyStrokeStyles={hasLegacyStrokeStyles ?? true}
    width="24"
    height="28"
    viewBox="0 0 24 28"
    fill="none"
    strokeWidth={strokeWidth}
    {...props}
  >
    <g filter="url(#filter0_d_3038_55)">
      <path
        d="M5.5 12C5.49974 10.5939 5.95542 9.2257 6.79867 8.10056C7.64193 6.97542 8.82729 6.15405 10.1769 5.75969C11.5265 5.36532 12.9677 5.41923 14.2841 5.91331C15.6005 6.40739 16.7212 7.31501 17.478 8.5"
        stroke="#141B4D"
        strokeWidth="2"
        strokeMiterlimit="10"
        strokeLinejoin="round"
      />
      <path
        d="M18.5 5.5V9.5H14.5"
        stroke="#141B4D"
        strokeWidth="2"
        strokeMiterlimit="10"
        strokeLinejoin="round"
      />
      <path
        d="M18.5 12C18.5002 13.4061 18.0446 14.7743 17.2013 15.8994C16.358 17.0246 15.1727 17.8459 13.8231 18.2403C12.4734 18.6347 11.0323 18.5808 9.71591 18.0867C8.39951 17.5926 7.27882 16.685 6.52197 15.5"
        stroke="#141B4D"
        strokeWidth="2"
        strokeMiterlimit="10"
        strokeLinejoin="round"
      />
      <path
        d="M5.5 18.4998V14.4998H9.5"
        stroke="#141B4D"
        strokeWidth="2"
        strokeMiterlimit="10"
        strokeLinejoin="round"
      />
    </g>
    <defs>
      <filter
        id="filter0_d_3038_55"
        x="-4"
        y="0"
        width="32"
        height="32"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy="4" />
        <feGaussianBlur stdDeviation="2" />
        <feComposite in2="hardAlpha" operator="out" />
        <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0" />
        <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_3038_55" />
        <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_3038_55" result="shape" />
      </filter>
    </defs>
  </BaseIcon>
);

RefreshIcon.displayName = 'RefreshIcon';
